import { env } from '@/config/env'
import { api } from '@/lib/axios'
import { appsignal } from '@/lib/appsignal'
import { router } from '@/routes'
import { configure } from '@services'
import '@/store/theme' // Initialize theme early to prevent flash
import { ErrorBoundary } from '@appsignal/react'
import { ErrorDisplay } from '@/pages/Error/ErrorDisplay'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import './styles/global.scss'

configure({
  baseUrl: env.apiUrl,
  fetcher: async (url, options) => {
    const response = await api.request({
      url,
      method: options.method as 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
      headers: options.headers as Record<string, string>,
      data: options.body,
    })

    const headers = {} as Record<string, string>
    Object.entries(response.headers).forEach(([key, value]) => {
      if (value !== undefined) {
        headers[key] = String(value)
      }
    })

    return new Response(JSON.stringify(response.data), {
      status: response.status,
      statusText: response.statusText,
      headers,
    })
  },
})

const content = <RouterProvider router={router} />

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {appsignal ? (
      <ErrorBoundary
        instance={appsignal}
        fallback={() => (
          <ErrorDisplay
            title="Something went wrong"
            description="An unexpected error occurred. Please try again."
            onGoHome={() => {
              window.location.href = '/'
            }}
          />
        )}
      >
        {content}
      </ErrorBoundary>
    ) : (
      content
    )}
  </StrictMode>
)
